import { render, staticRenderFns } from "./MeetLDW.vue?vue&type=template&id=89cebff8&scoped=true&"
import script from "./MeetLDW.vue?vue&type=script&lang=js&"
export * from "./MeetLDW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cebff8",
  null
  
)

export default component.exports